module.exports = __webpack_public_path__ + "static/TiemposTextWeb-Semibold-79690725ac4385d644fa9e868b510008.woff";